import React from 'react';
import { CheckCircle2, Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ApplicationSuccess() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg border border-border p-8 text-center">
        <div className="flex justify-center mb-6">
          <CheckCircle2 className="w-20 h-20 text-accent animate-bounce" />
        </div>
        
        <h1 className="text-3xl font-bold text-primary mb-4">
          Bewerbung erfolgreich!
        </h1>
        <p className="text-muted-foreground mb-8">
          Vielen Dank für Ihr Interesse an der ENVISU GmbH. Ihre Daten wurden sicher an unser QA-Team übermittelt.
        </p>

        <div className="bg-secondary/10 border border-secondary/20 p-6 rounded-lg mb-8 text-left">
          <div className="flex items-center gap-3 text-primary font-semibold mb-3">
            <Calendar className="w-6 h-6 text-accent" />
            <span>Nächster Schritt: Termin vereinbaren!</span>
          </div>
          <p className="text-sm text-secondary leading-relaxed mb-4">
            Um den Prozess zu beschleunigen, können Sie sich direkt hier ganz flexibel Ihren Wunschtermin für unser erstes Kennenlerngespräch aussuchen.
          </p>
          <a
            href="https://calendly.com/kontakt-envisu-gmbh/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-2 bg-accent text-white px-4 py-3 rounded-md font-bold hover:bg-accent/90 transition-colors"
          >
            Jetzt Calendly Termin buchen
          </a>
        </div>

        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 border border-border text-secondary px-6 py-3 rounded-md font-medium hover:bg-slate-50 transition-colors w-full"
        >
          Zurück zur Startseite <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
